/**
 * Payment gateway return URLs may use checkoutId, checkout_id, or checkout (e.g. Paymennt).
 */
export function getCheckoutIdFromSearchParams(searchParams) {
  if (!searchParams) return null;
  return (
    searchParams.get('checkoutId') ||
    searchParams.get('checkout_id') ||
    searchParams.get('checkout') ||
    null
  );
}
